var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpMenuKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1 17V16H9.25V16.25C9.25 16.6642 9.58579 17 10 17C10.4142 17 10.75 16.6642 10.75 16.25V16H19V17C19 17.5523 18.5523 18 18 18H12C12 18.5523 11.5523 19 11 19H9C8.44772 19 8 18.5523 8 18H2C1.44772 18 1 17.5523 1 17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3.04132C7.30263 1.65289 1.94737 1.65289 0 3.04132V16H9.25V3.04132Z",
    fill: "currentColor",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3.04132C12.6974 1.65289 18.0526 1.65289 20 3.04132V16H10.75V3.04132Z",
    fill: "currentColor",
    fillOpacity: 0.55
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpMenuKnowledge);
export default __webpack_public_path__ + "static/media/icon-help-menu-knowledge.cfb1e8350a0b22ab7468654ce4d24cdf.svg";
export { ForwardRef as ReactComponent };